module.exports = __webpack_public_path__ + "static/media/options.0238f7b8.png";